import { IonButton, IonButtons, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonLabel, IonRow, IonTitle, IonToast, IonToolbar } from '@ionic/react';
import { arrowBack, cardOutline, cashOutline, qrCodeOutline, walletOutline } from 'ionicons/icons';
import React, { useState } from 'react';

type Props = {
  projetoid: string;
  formaPagamentoAtual: string;
  dadosEmpresa: any;
  onClose: () => void;
  onConfirm: (formaPagamento: string) => void;
};

function iconePagamento(tipo: string) {
  const t = (tipo || '').toLowerCase();
  if (t.includes('credito') || t.includes('crédito') || t.includes('debito') || t.includes('débito') || t.includes('cartao') || t.includes('cartão')) return cardOutline;
  if (t.includes('pix')) return qrCodeOutline;
  if (t.includes('dinheiro')) return cashOutline;
  return walletOutline;
}

const AlterarPagamentoSimplesModal: React.FC<Props> = ({ projetoid, formaPagamentoAtual, dadosEmpresa, onClose, onConfirm }) => {

  const [selecionado, setSelecionado] = useState<string>(formaPagamentoAtual || '');
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState('');

  const formasPagamento: any[] = dadosEmpresa?.formaPagamento || [];

  return (
    <>
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonIcon slot="icon-only" icon={arrowBack} onClick={onClose} />
          </IonButtons>
          <IonTitle>Forma de Pagamento</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen={false}>
        <IonGrid>
          <IonRow className="ion-justify-content-center" style={{ paddingTop: "20px", textAlign: "center", fontSize: "20px" }}>
            <IonLabel>Selecione a forma de pagamento</IonLabel>
          </IonRow>

          <IonRow className="ion-justify-content-center" style={{ paddingTop: "20px", flexWrap: 'wrap', gap: '8px' }}>
            {formasPagamento.filter((item: any) => item.exibirPdv).map((item: any, index: number) => {
              const isSelected = selecionado === item.nome;
              return (
                <IonCol size="auto" key={index}>
                  <IonButton
                    style={{ height: '40px', fontSize: '13px', margin: '0px' }}
                    expand="block"
                    shape="round"
                    color={isSelected ? 'primary' : 'light'}
                    onClick={() => setSelecionado(item.nome)}
                  >
                    <IonIcon icon={iconePagamento(item.tipo || item.nome)} style={{ fontSize: '18px', marginRight: '6px' }} />
                    {item.nome.toUpperCase()}
                  </IonButton>
                </IonCol>
              );
            })}
          </IonRow>

          {selecionado && (
            <IonRow className="ion-justify-content-center" style={{ paddingTop: "30px", textAlign: "center" }}>
              <IonLabel style={{ fontSize: '16px', color: '#333' }}>
                Selecionado: <b>{selecionado}</b>
              </IonLabel>
            </IonRow>
          )}

          <IonRow className="ion-justify-content-center" style={{ paddingTop: "30px" }}>
            <IonCol size="10">
              <IonButton
                style={{ height: "46px", fontSize: "18px" }}
                expand="block"
                onClick={() => {
                  if (!selecionado) {
                    setTextToast('Selecione uma forma de pagamento.');
                    setShowToast(true);
                    return;
                  }
                  onConfirm(selecionado);
                }}
              >
                Salvar
              </IonButton>
            </IonCol>
          </IonRow>
          <IonRow className="ion-justify-content-center">
            <IonCol size="10">
              <IonButton
                style={{ height: "46px", fontSize: "18px" }}
                expand="block"
                fill="outline"
                color="medium"
                onClick={onClose}
              >
                Cancelar
              </IonButton>
            </IonCol>
          </IonRow>
        </IonGrid>

        <IonToast isOpen={showToast} position="middle" onDidDismiss={() => setShowToast(false)} message={textToast} duration={3000} />
      </IonContent>
    </>
  );
};

export default AlterarPagamentoSimplesModal;
